// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-header {
  position: relative;
  z-index: 100;
  display: grid;
  grid-template-rows: var(--mobile-header-size) auto;
  grid-template-columns: 100%;
}
.mobile-header__content {
  min-height: calc(100vh - var(--mobile-header-size));
  overflow-x: auto;
  height: 0;
}
.mobile-header__logo_rebranding {
  flex: 1;
}
.mobile-header__link {
  -webkit-text-decoration: none;
  text-decoration: none;
  outline: none;
  color: inherit;
  display: block;
  height: 100%;
  flex: 1 1 auto;
}
.mobile-header__logo-icon {
  color: var(--g-color-base-brand);
}
.mobile-header__logo-icon_rebranding {
  height: auto;
  width: auto;
  padding-left: var(--g-spacing-2);
}
.mobile-header__user-avatar {
  cursor: pointer;
}
.mobile-header .gn-burger-composite-bar .gn-burger-composite-bar__item-icon,
.mobile-header .gn-mobile-header-footer-item .gn-mobile-header-footer-item__icon {
  color: var(--gn-aside-header-item-icon-color);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MobileHeader/MobileHeader.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kDAAA;EACA,2BAAA;AACJ;AACI;EACI,mDAAA;EACA,gBAAA;EACA,SAAA;AACR;AAEI;EACI,OAAA;AAAR;AAGI;EACI,6BAAA;EAAA,qBAAA;EACA,aAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;AADR;AAII;EACI,gCAAA;AAFR;AAIQ;EACI,YAAA;EACA,WAAA;EACA,gCAAA;AAFZ;AAMI;EACI,eAAA;AAJR;AAQI;;EAEI,6CAAA;AANR","sourcesContent":[".mobile-header {\n  position: relative;\n  z-index: 100;\n  display: grid;\n  grid-template-rows: var(--mobile-header-size) auto;\n  grid-template-columns: 100%;\n}\n.mobile-header__content {\n  min-height: calc(100vh - var(--mobile-header-size));\n  overflow-x: auto;\n  height: 0;\n}\n.mobile-header__logo_rebranding {\n  flex: 1;\n}\n.mobile-header__link {\n  text-decoration: none;\n  outline: none;\n  color: inherit;\n  display: block;\n  height: 100%;\n  flex: 1 1 auto;\n}\n.mobile-header__logo-icon {\n  color: var(--g-color-base-brand);\n}\n.mobile-header__logo-icon_rebranding {\n  height: auto;\n  width: auto;\n  padding-left: var(--g-spacing-2);\n}\n.mobile-header__user-avatar {\n  cursor: pointer;\n}\n.mobile-header .gn-burger-composite-bar .gn-burger-composite-bar__item-icon,\n.mobile-header .gn-mobile-header-footer-item .gn-mobile-header-footer-item__icon {\n  color: var(--gn-aside-header-item-icon-color);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
